export function EmptyCellValue(): JSX.Element {
  return <span className='text-gray-400 font-lato'>—</span>
}
